export const locales = [
  'fr',
  'es',
  'de',
  'en',
  'it',
  'pl',
  'nl',
  'pt',
  'ro',
  'se',
  'da',
  'no',
  'cz',
  'gr',
  'bg',
  'si',
  'fi',
  'lt',
  'ee',
  'lv',
  'rs',
  'hr',
  'sk',
];

export const languagePicker = {
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  en: 'English',
  it: 'Italiano',
  pl: 'Polski',
  nl: 'Nederlands',
  pt: 'Português',
  ro: 'Română',
  se: 'Svenska',
  da: 'Dansk',
  no: 'Norsk',
  cz: 'Čeština',
  gr: 'Ελληνικά',
  bg: 'Български',
  si: 'Slovenščina',
  fi: 'Suomi',
  lt: 'Lietuvių',
  ee: 'Eesti',
  lv: 'Latviešu',
  rs: 'Српски',
  hr: 'Hrvatski',
  sk: 'Slovenčina',
};
